import { useTranslation } from "react-i18next";
import { Spinner } from "../LoadingAnimations/LoadingAnimations";
import { useEffect, useState } from "react";

const EXIT_DURATION = 300;

/**
 * ActionFeedback – a non-blocking notification that slides in from the
 * top-right, auto-dismisses after `duration` ms, and slides back out.
 *
 * @param {string}   message   - Text to display.
 * @param {string}   variant   - "success" | "error" | "warning" | "info"
 * @param {number}   duration  - Auto-dismiss delay in ms (default 3500).
 * @param {Function} close     - Called once the exit animation completes.
 */
export const ActionFeedback = ({
  message,
  variant = "success",
  duration = 3500,
  close,
}) => {
  const [exiting, setExiting] = useState(false);

  const dismiss = () => {
    setExiting(true);
    setTimeout(close, EXIT_DURATION);
  };

  useEffect(() => {
    const timer = setTimeout(dismiss, duration);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`action-feedback action-feedback--${variant}${
        exiting ? " action-feedback--exiting" : ""
      }`}
      role="alert"
      aria-live="polite"
    >
      <span className="action-feedback__message">{message}</span>
      <button
        type="button"
        className="action-feedback__close"
        onClick={dismiss}
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  );
};
export const ActionResponse = ({ message, status, close }) => {
  const { t } = useTranslation();
  return (
    <div className="page-mask-2 page-mask-animation ">
      <div className="success-message" data-testid="response-modal">
        <h2 className="global-h2">{status}</h2>
        <h3 className="global-h4 gray">{message}</h3>
        <button className="change-pwd-btn" type="button" onClick={close}>
          {t("buttons.close")}
        </button>
      </div>
    </div>
  );
};

export const ActionConfirm = ({
  title,
  message,
  warning,
  confirm,
  close,
  requestLoading,
  error
}) => {
  const { t } = useTranslation();
  return (
    <div className="page-mask-2 page-mask-animation">
      <div className="success-message">
        <h2 className="global-h2">{title}</h2>
        <h3 className="global-h4 gray">{message}</h3>
        {warning && <h3 className="global-h4 critical">{warning}</h3>}
        {error && <p className="error">{error}</p>}
        {requestLoading ? (
          <Spinner />
        ) : (
          <div className="full-cont">
            <button onClick={() => confirm()} className="change-pwd-btn">
              {t("buttons.submit")}
            </button>
            <button onClick={() => close()} className="close-btn">{t("buttons.close")}</button>
          </div>
        )}
      </div>
    </div>
  );
};

export const NewActionConfirm = ({
  title,
  message,
  warning,
  confirm,
  close,
  requestLoading,
  error
}) => {
  const { t } = useTranslation();
  return (
    <div className="page-mask-2 page-mask-animation">
      <div className="success-message">
        <h2 className="global-h2">{title}</h2>
        <h3 className="global-h4 gray">{message}</h3>
        {warning && <h3 className="global-h4 critical">{warning}</h3>}
        {error && <p className="error">{error}</p>}
        {requestLoading ? (
          <Spinner />
        ) : (
          <div className="full-cont">
            <button onClick={() => confirm()} className="change-pwd-btn">
              {t("buttons.submit")}
            </button>
            <button onClick={() => close()} className="close-btn">{t("buttons.close")}</button>
          </div>
        )}
      </div>
    </div>
  );
}